// extracted by mini-css-extract-plugin
module.exports = {"Home":"Page_Home__zPvBm"};